import { Vector2 } from 'three'

export const TerrainInitialState = {
  data: {
    gridOrigin: new Vector2(-1, -1),
    grid: [[]],
    isLocked: true,
    selectedTile: null,
    selectedElementUUID: null,
    treasures: [],
    gravestones: []
  },
  terrain: {},
}
